import {
  Button,
  CloseButton,
  Flex,
  Heading,
  Modal,
  Spinner,
  Text,
  TextInput,
} from "@instructure/ui";
import { useCallback, useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router";
import { PurlService } from "../../../services/PurlService";
import { auth } from "../../../utils/auth";
import { UserDetailContext } from "../../../utils/Context";
import { ERROR, useNotification } from "../../CustomHooks/NotificationProvider";

const ConfirmedModal = ({ open, setUser, shareCode }) => {
  const { t } = useTranslation();
  const userDetails = useContext(UserDetailContext);
  const showNotification = useNotification();
  const [email, setEmail] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const handleConfirm = useCallback(
    (email) => {
      setLoading(true);
      PurlService.verifyEmail(shareCode, email, true)
        .then(() => {
          setUser(email);
        })
        .catch(() => {
          setLoading(false);
          showNotification(t("notifications.shareCode.verifyError"), ERROR);
        });
    },
    [setUser, shareCode, showNotification]
  );

  // Automatically login if a canvas user
  useEffect(() => {
    if (userDetails.email) {
      setEmail(userDetails.email);
      handleConfirm(userDetails.email);
    }
  }, [userDetails, handleConfirm]);

  return (
    (!auth || userDetails.ddl_id) && (
      <Modal
        open={open}
        size="medium"
        label={t("juriedAssessment.confirmEmailDialog")}
        shouldCloseOnDocumentClick={false}
      >
        <Modal.Header>
          <Flex justifyItems="space-between">
            <Flex.Item>
              <Heading level="h2" as="h1">
                {t("juriedAssessment.confirmEmail")}
              </Heading>
            </Flex.Item>
            {auth && (
              <Flex.Item>
                <CloseButton
                  offset="small"
                  onClick={() => navigate("/")}
                  screenReaderLabel={t("global.close")}
                />
              </Flex.Item>
            )}
          </Flex>
        </Modal.Header>
        <Modal.Body>
          <Flex wrap="wrap">
            <Flex.Item shouldGrow size="100%" margin="0 0 small 0">
              <Text as="p">{t("juriedAssessment.confirmEmailContinue")}</Text>
            </Flex.Item>
            <Flex.Item shouldGrow>
              <TextInput
                size="small"
                width="100%"
                id="email-address-confirm"
                renderLabel={
                  <Text size="small">{t("juriedAssessment.emailAddress")}</Text>
                }
                value={email}
                onChange={(e) => setEmail(e.target.value)}
              />
            </Flex.Item>
          </Flex>
        </Modal.Body>
        <Modal.Footer>
          <Button
            onClick={() => handleConfirm(email)}
            color="primary"
            disabled={loading}
          >
            {loading ? (
              <Spinner renderTitle={t("global.pleaseWait")} size="x-small" />
            ) : (
              t("global.submit")
            )}
          </Button>
        </Modal.Footer>
      </Modal>
    )
  );
};

export default ConfirmedModal;
